// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import Switch from '../../../../components/common/Switch';
import colors from '../../../../styled-components/palette';
import { NewTag } from '../../../../styled-components/shared';

const LIST_ITEM_HEIGHT = 3.3; // em

const Wrapper = styled.div`
  height: ${LIST_ITEM_HEIGHT}em;
  padding: 0 0.5em;
  font-size: 1em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.bluegrey900};
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  color: #fff;

  &:active {
    background-color: ${colors.bluegrey850};
  }

  &:hover {
    background-color: ${colors.bluegrey850};
  }

  &:not(:first-child) {
    &::before {
      content: '';
      background-color: ${colors.bluegrey800};
      position: absolute;
      left: 0;
      right: 0;
      height: 1px;
      top: 0;
    }
  }

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          background-color: ${colors.bluegrey850};
        }
      `
    : null}
`;

const Icon = styled.div`
  margin-left: 0.2em;
  margin-right: 0.5em;
  display: flex;
  align-items: center;
  width: 1.7em;
  height: 1.7em;
`;

const Label = styled.span`
  padding-right: 0.3em;
  height: 100%;
  display: flex;
  align-items: center;
  font-weight: normal;
`;

const StyledNewTag = styled(NewTag)`
  margin-right: 1em;

  &:last-child {
    margin-left: auto;
  }
`;

const StyledSwitch = styled(Switch)`
  margin-left: auto;
`;

type BetslipOptionsItemSwitchProps = {
  className?: string;
  showNewTag?: boolean;
  onToggle: () => void;
  isToggled?: boolean;
  label: string;
  icon?: unknown;
};

const BetslipOptionsItemSwitch = ({
  className = '',
  showNewTag = false,
  onToggle,
  isToggled = false,
  label,
  icon,
}: BetslipOptionsItemSwitchProps) => {
  return (
    <Wrapper className={className} onClick={onToggle}>
      {icon ? <Icon>{icon}</Icon> : null}
      <Label>{label}</Label>
      {showNewTag ? <StyledNewTag>New</StyledNewTag> : null}
      <StyledSwitch toggled={isToggled} onToggle={onToggle} />
    </Wrapper>
  );
};

export default BetslipOptionsItemSwitch;
